import { Order } from '../../shared/enums/order.enum';
import { SortedPageInfo } from '../../../core/model/pagination/sorted-page-info';

/**
 * Class represents required parameters to fetch application list.
 */
export class ApplicationListParams extends SortedPageInfo {
    constructor(page: number, itemsPerPage: number) {
        super(page, itemsPerPage, ['name'], [Order.ASC]);
    }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/model/application-list-params.ts